import { formatDateForSeparator } from "@/features/chat/lib";
import React from "react";

interface DateSeparatorProps {
  date: Date;
}

export const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
  return (
    <div className="d-flex justify-content-center my-3">
      <span
        className="bg-secondary text-white px-3 py-1 rounded-pill"
        style={{ fontSize: "12px", fontWeight: 500 }}
      >
        {formatDateForSeparator(date)}
      </span>
    </div>
  );
};